<template>
  <div>
    <v-layout row wrap>
      <v-flex class="px-2" xs12 sm4 md4>
        <v-text-field label="Search Here" v-model="searchQuery"></v-text-field>
      </v-flex>
      <v-flex class="px-2" xs12 sm2 md2>
        <v-select
          :items="searchOptions"
          v-model="selectedSearchOption"
          item-value="value"
          item-text="text"
          return-object
        ></v-select>
      </v-flex>
      <v-flex class="px-2" xs12 sm2 md2>
        <v-btn color="primary" @click="search">Search</v-btn>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1"
      :options.sync="pagination"
      :server-items-length="totalItems"
      :loading="loading"
      :footer-props="footerProps"
    >
      <template slot="items" slot-scope="props">
        <td v-for="(header, index) in headers" :key="index">
          <span v-if="!header.html">{{ props.item[header.value] }}</span>
          <span v-if="header.html" v-html="props.item[header.value]">{{props.item[header.value]}}</span>
          <!-- <span v-if="header.value == 'actions'">
            <slot name="actions" v-bind:item="props.item"></slot>
          </span>-->
        </td>
      </template>
      <template v-slot:item.action="{ item }">
        <slot name="actions" v-bind:item="item"></slot>
      </template>
      <template v-slot:no-data>
        <v-alert
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ searchQuery }}" found no results.</v-alert>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  data: () => ({
    pagination: {
      page: 1,
      pageSize: 10
    },
    selectedSearchOption: {},
    searchQuery: "",
    searchBy: ""
  }),
  methods: {
    ...mapActions("religion", [
      "getAll",
      "setPagination",
      "setSelectedSearchOption"
    ]),
    search() {
      const { value } = this.selectedSearchOption;
      this.searchBy = value;
      this.setSelectedSearchOption({
        searchBy: this.searchBy,
        searchQuery: this.searchQuery
      });

      this.getAll();
    }
  },
  computed: {
    ...mapState("religion", {
      items: state => state.items,
      headers: state => state.headers,
      footerProps: state => state.footerProps,
      totalItems: state => state.totalItems,
      searchOptions: state => state.searchOptions,
      loading: state => state.loading
    })
  },
  watch: {
    pagination: {
      handler(val) {
        this.setPagination(Object.assign({}, val));
        this.search();
      },
      deep: true
    }
  },
  mounted() {
    this.selectedSearchOption = this.searchOptions[0];
  }
};
</script>
